import {Component, computed, signal} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-global-error-page',
    templateUrl: './global-error-page.component.html',
    styleUrl: './global-error-page.component.scss',
    imports: [
        MatIcon,
        RouterLink,
        TranslocoPipe,
    ],
})
export class GlobalErrorPageComponent {
  type = signal<AppErrorType>(AppErrorType.NOT_FOUND);
  title = computed(() => `globalError.${this.type()}.title`)
  subtitle = computed(() => `globalError.${this.type()}.subtitle`)
  body = computed(() => `globalError.${this.type()}.body`)

  constructor(route: ActivatedRoute) {
    route.params.subscribe(params => {
      const type = params['type'] as AppErrorType;
      if (!type) {
        return;
      }

      switch (type) {
        case AppErrorType.UNKNOWN:
        case AppErrorType.NOT_FOUND:
          this.type.set(type)
          return;
        default:
          this.type.set(AppErrorType.UNKNOWN);
      }
    })
  }

}

export enum AppErrorType {
  UNKNOWN = 'unknown',
  NOT_FOUND = 'notFound'
}
